import c, { PureComponent as R } from "react";
import z from "../../../../_virtual/isFunction.js";
import { clsx as w } from "../../../clsx/dist/clsx.js";
import { Layer as P } from "../container/Layer.js";
import { Dot as C } from "../shape/Dot.js";
import { Polygon as $ } from "../shape/Polygon.js";
import { Text as F } from "../component/Text.js";
import { adaptEventsOfChild as B } from "../util/types.js";
import { filterProps as b } from "../util/ReactUtils.js";
import { polarToCartesian as _, getTickClassName as K } from "../util/PolarUtils.js";
function d(t) {
  "@babel/helpers - typeof";
  return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, d(t);
}
function f() {
  return f = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, f.apply(this, arguments);
}
function A(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function u(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? A(Object(n), !0).forEach(function(r) {
      x(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : A(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function M(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function L(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, S(r.key), r);
  }
}
function V(t, e, n) {
  return e && L(t.prototype, e), n && L(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function q(t, e, n) {
  return e = g(e), G(t, E() ? Reflect.construct(e, n || [], g(t).constructor) : e.apply(t, n));
}
function G(t, e) {
  if (e && (d(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return H(t);
}
function H(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function E() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (E = function() {
    return !!t;
  })();
}
function g(t) {
  return g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, g(t);
}
function J(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && T(t, e);
}
function T(t, e) {
  return T = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, T(t, e);
}
function x(t, e, n) {
  return e = S(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function S(t) {
  var e = Q(t, "string");
  return d(e) == "symbol" ? e : e + "";
}
function Q(t, e) {
  if (d(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (d(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var U = Math.PI / 180, W = 1e-5, j = /* @__PURE__ */ function(t) {
  function e() {
    return M(this, e), q(this, e, arguments);
  }
  return J(e, t), V(e, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(r) {
        var i = this.props, a = i.cx, o = i.cy, s = i.radius, p = i.orientation, y = i.tickSize, m = y || 8, v = _(a, o, s, r.coordinate), h = _(a, o, s + (p === "inner" ? -1 : 1) * m, r.coordinate);
        return {
          x1: v.x,
          y1: v.y,
          x2: h.x,
          y2: h.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(r) {
      var i = this.props.orientation, a = Math.cos(-r.coordinate * U), o;
      return a > W ? o = i === "outer" ? "start" : "end" : a < -1e-5 ? o = i === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.cx, a = r.cy, o = r.radius, s = r.axisLine, p = r.axisLineType, y = u(u({}, b(this.props, !1)), {}, {
        fill: "none"
      }, b(s, !1));
      if (p === "circle")
        return /* @__PURE__ */ c.createElement(C, f({
          className: "recharts-polar-angle-axis-line"
        }, y, {
          cx: i,
          cy: a,
          r: o
        }));
      var m = this.props.ticks, v = m.map(function(h) {
        return _(i, a, o, h.coordinate);
      });
      return /* @__PURE__ */ c.createElement($, f({
        className: "recharts-polar-angle-axis-line"
      }, y, {
        points: v
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var r = this, i = this.props, a = i.ticks, o = i.tick, s = i.tickLine, p = i.tickFormatter, y = i.stroke, m = b(this.props, !1), v = b(o, !1), h = u(u({}, m), {}, {
        fill: "none"
      }, b(s, !1)), N = a.map(function(l, k) {
        var O = r.getTickLineCoord(l), D = r.getTickTextAnchor(l), I = u(u(u({
          textAnchor: D
        }, m), {}, {
          stroke: "none",
          fill: y
        }, v), {}, {
          index: k,
          payload: l,
          x: O.x2,
          y: O.y2
        });
        return /* @__PURE__ */ c.createElement(P, f({
          className: w("recharts-polar-angle-axis-tick", K(o)),
          key: "tick-".concat(l.coordinate)
        }, B(r.props, l, k)), s && /* @__PURE__ */ c.createElement("line", f({
          className: "recharts-polar-angle-axis-tick-line"
        }, h, O)), o && e.renderTickItem(o, I, p ? p(l.value, k) : l.value));
      });
      return /* @__PURE__ */ c.createElement(P, {
        className: "recharts-polar-angle-axis-ticks"
      }, N);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.ticks, a = r.radius, o = r.axisLine;
      return a <= 0 || !i || !i.length ? null : /* @__PURE__ */ c.createElement(P, {
        className: w("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, a) {
      var o;
      return /* @__PURE__ */ c.isValidElement(r) ? o = /* @__PURE__ */ c.cloneElement(r, i) : z(r) ? o = r(i) : o = /* @__PURE__ */ c.createElement(F, f({}, i, {
        className: "recharts-polar-angle-axis-tick-value"
      }), a), o;
    }
  }]);
}(R);
x(j, "displayName", "PolarAngleAxis");
x(j, "axisType", "angleAxis");
x(j, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
export {
  j as PolarAngleAxis
};
